import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { register, retrieve, retrieveBankData, retrieveCurrencyTypes } from '../services/banks';

// REGISTER A NEW BANK
export const registerBank = createAsyncThunk('bank/register', async (args, { getState }) => {
    const { bank } = getState();
    const response = await register({
        "banco": bank.bankName.value,
        "moneda": bank.accountCurrency.value,
        "TipoCuentas": bank.accountType.value,
        "nombre": bank.accountName.value,
        "cuenta": bank.accountNumber.value,
        "id": args["id"],
        "u": args["u"]
        // "Bank_Alias": "",
    });
    return { response: response.data, statusCode: response.status };
});


// RETRIEVE BANKS BY COUNTRY
export const retrieveBanks = createAsyncThunk('bank/retrieve', async (args, { getState }) => {
    const { user } = getState();
    let countries = {
        "GTM": "Guatemala",
        "GT": "Guatemala",
        "HN": "Honduras",
        "SV": "El Salvador",
        "PA": "Panama",
        "US": "United States",
        "CR": "Costa Rica"
    }
    const response = await retrieve({ country: countries[user.country.value] });
    return { response: response.data, statusCode: response.status };
});

// RETRIEVE BANKS DETAILS
export const retrieveBanksDetails = createAsyncThunk('bank/retrieveDetails', async (args, { getState }) => {
    const { user } = getState();
    const response = await retrieveBankData({ countryCode: user.country.value });
    return { response: response.data, statusCode: response.status };
});

function validarTarjeta(numTarjeta) {
    // ---> Convertimos a números
    const digitos = String(numTarjeta).split('').map(Number);
    
    // ---> La longitud mínima de una tarjeta es 13
    if (digitos.length < 13) { return false; }
    
    // ---> Solo validamos cada segundo número
    const digitosInvertidos = digitos.reverse();
    let suma = 0;

    // ---> Validamos el número
    digitosInvertidos.forEach((digito, i) => {
        if (i % 2 === 1) { // ---> Tiene que ser el doble del número anterior
            digito *= 2;
            if (digito > 9) { // ---> No debe ser mayor de 10
                digito -= 9;
            }
        }
        suma += digito;
    });

    // ---> Es válido si es múltiplo de 10
    return suma % 10 === 0;
}

export const bankSlice = createSlice({
    name: 'bank',
    initialState: {
        country: "",
        nit: { value: "", error: true },
        bankName: { value: "", error: true },
        swiftCode: { value: "", error: true },
        accountType: { value: "", error: true },
        accountName: { value: "", error: true },
        accountNumber: { value: "", error: true },
        accountNumberConfirm: { value: "", error: true },
        accountCurrency: { value: "", error: true }
    },
    reducers: {
        setCountry: (state, action) => { state.country = action.payload },
        setNit: (state, action) => { state.nit = action.payload },
        setBankName: (state, action) => { state.bankName = action.payload },
        setSwiftCode: (state, action) => { state.swiftCode = action.payload },
        setAccountType: (state, action) => { state.accountType = action.payload },
        setAccountName: (state, action) => {
            let Value = `${action.payload.value}`;
            action.payload["error"] = !/^[A-Za-záéíóúäëïöüÄËÏÖÜ\s]{2,}$/.test(Value)||Value.length<4;
            state.accountName = action.payload
        },
        setAccountNumber: (state, action) => {
            const regex = /^[0-9]+$/;
            let Value = `${action.payload.value}`;
            //----> Valido que el número de cuenta tenga 16 digitos o menos y que no sea un numero de tarjeta
            action.payload["error"] = !regex.test(Value)||Value.length>16||validarTarjeta(Value);
            state.accountNumber = action.payload

            //----> Según el código anterior; CR acepta letras (busque información y no encontré, pero lo dejo por si acaso)
            //----> Solo valido que deba tener más de 4 caracteres;
            if(state.country=="CR"){ state.accountNumber.error = Value.length!=20; };

            //----> Valido el campo de confirmación;
            state.accountNumberConfirm.error = state.accountNumber.value!=state.accountNumberConfirm.value;
        },
        setAccountNumberConfirm: (state, action) => {
            state.accountNumberConfirm = action.payload;
            state.accountNumberConfirm.error = state.accountNumber.value!=state.accountNumberConfirm.value;
        },
        setAccountCurrency: (state, action) => { state.accountCurrency = action.payload },
        setBankData: (state, action) => {
            if (action?.payload) {
                const reducers = bankSlice.caseReducers;
        
                for (let prop in action.payload) {
                    if (state.hasOwnProperty(prop)) {
                        const setterName = `set${prop.charAt(0).toUpperCase()}${prop.slice(1)}`;
                        const fieldValue = action.payload[prop];
        
                        // Si existe un reducer específico para ese campo, lo invocamos
                        if (typeof reducers[setterName] === "function") {
                            reducers[setterName](state, { payload: { value: fieldValue, error: false } });
                        } 
                        // Si no, hacemos el seteo genérico (sin validación)
                        else if (state[prop]?.value !== undefined) {
                            state[prop] = {
                                ...state[prop],
                                value: fieldValue,
                                error: false
                            };
                        } 
                        // Si es un campo primitivo como country
                        else {
                            state[prop] = fieldValue;
                        }
                    }
                }
        
                if (action.payload.nullifier_hash) {
                    state.idWLD = action.payload.nullifier_hash;
                }
            }
        }        
    },
})

// RETUNR COUNTRY CURRENCY 
export const retriveCurrency = createAsyncThunk('bank/retriveCurrency', async (args, { getState }) => {
    // const { user } = getState();
    const response = await retrieveCurrencyTypes({ countryCode: args.country });
    return { response: response.data, statusCode: response.status };
});

// Action creators are generated for each case reducer function
export const { setNit, setBankName, setSwiftCode, setAccountType, setAccountName, setAccountNumber, setAccountNumberConfirm, setAccountCurrency, setCountry, setBankData } = bankSlice.actions
export default bankSlice.reducer